// filters date and time collections

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

let formatDate =  function(value, format = 'MM/DD/YYYY', locale) {
  locale = locale || 'en';

  if (value ) {
    require(`dayjs/locale/${locale}.js`);
    dayjs.extend(customParseFormat);
    return dayjs(Date.parse(value)).locale(locale).format(format);
  }
}


export { formatDate }
